export default __webpack_public_path__ + "static/media/i215vp.3fb6b15b.webp";